import React from 'react';
import { MessageSquarePlus, Trash2, MessageCircle } from 'lucide-react';
import { RemindersPanel } from '@/components/ai/RemindersPanel';

const dayLabel = (iso) => {
  const d = new Date(iso);
  const today = new Date();
  const diff = Math.floor((today.setHours(0, 0, 0, 0) - new Date(d).setHours(0, 0, 0, 0)) / 86400000);
  if (diff <= 0) return 'Today';
  if (diff === 1) return 'Yesterday';
  if (diff < 7) return 'This week';
  return 'Earlier';
};

// Conversation list with a "New chat" button; groups by recency.
export const ChatSidebar = ({ chats, activeId, onSelect, onNew, onDelete, reminders = [], onCancelReminder }) => {
  const groups = chats.reduce((acc, c) => {
    const key = dayLabel(c.updated_at);
    (acc[key] = acc[key] || []).push(c);
    return acc;
  }, {});
  const order = ['Today', 'Yesterday', 'This week', 'Earlier'].filter((k) => groups[k]);

  return (
    <aside className="chat-sidebar" data-testid="chat-sidebar">
      <button type="button" className="chat-new" onClick={onNew} data-testid="chat-new-button">
        <MessageSquarePlus size={16} /> New chat
      </button>
      <div className="chat-list">
        {!chats.length && (
          <p className="chat-list-empty" data-testid="chat-list-empty">No conversations yet. Ask anything about your team's work — or anything at all.</p>
        )}
        {order.map((key) => (
          <div key={key} className="chat-group">
            <div className="chat-group-label">{key}</div>
            {groups[key].map((c) => (
              <div key={c.id} className={`chat-item ${c.id === activeId ? 'active' : ''}`}>
                <button type="button" className="chat-item-main" onClick={() => onSelect(c.id)} data-testid={`chat-item-${c.id}`}>
                  <MessageCircle size={14} aria-hidden="true" />
                  <span className="chat-item-title">{c.title}</span>
                </button>
                <button type="button" className="chat-item-delete" onClick={() => onDelete(c)} aria-label={`Delete chat ${c.title}`} data-testid={`chat-delete-${c.id}`}>
                  <Trash2 size={13} />
                </button>
              </div>
            ))}
          </div>
        ))}
      </div>
      <RemindersPanel reminders={reminders} onCancel={onCancelReminder} onOpenChat={onSelect} />
    </aside>
  );
};
